import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api/chat'
  : `http://${window.location.hostname}:3001/api/chat`;

// Environment-aware logging - silent in production
const isDev = process.env.NODE_ENV !== 'production';
const log = (...args) => isDev && console.log(...args);

// Store session ID for ongoing conversations
let currentSessionId = null;

export const chatWithClaude = async (messages, missionParams = null, options = {}) => {
  try {
    const payload = { 
      messages,
      sessionId: options.sessionId || currentSessionId
    };
    
    if (missionParams) {
      payload.missionParams = missionParams;
    }
    
    const response = await axios.post(API_URL, payload);
    
    // Store session ID from response for ongoing conversation
    if (response.data.sessionId) {
      currentSessionId = response.data.sessionId;
    }
    
    return response.data.message;
  } catch (error) {
    if (isDev) console.error('Error communicating with Claude:', error);
    throw error;
  }
};

// Enhanced version that also extracts scene data for image generation
export const chatWithClaudeForComic = async (messages, missionParams = null, options = {}) => {
  try {
    const payload = { 
      messages,
      comicMode: true,
      sessionId: options.sessionId || currentSessionId
    };
    
    if (missionParams) {
      payload.missionParams = missionParams;
    }
    
    const response = await axios.post(API_URL, payload);
    
    // Store session ID from response for ongoing conversation
    if (response.data.sessionId) {
      currentSessionId = response.data.sessionId;
    }
    
    // Log verified event info if present (for debugging)
    if (response.data.verifiedEvent) {
      log('[CLAUDE] Verified Event:', response.data.verifiedEvent);
    }
    
    return {
      message: response.data.message,
      sceneData: response.data.sceneData || null,
      sessionId: response.data.sessionId,
      verifiedEvent: response.data.verifiedEvent || null
    };
  } catch (error) {
    if (isDev) console.error('Error communicating with Claude:', error);
    throw error;
  }
};

// Reset session (call when starting a new mission)
export const resetSession = () => {
  currentSessionId = null;
};

// Get current session ID
export const getSessionId = () => currentSessionId;

export default chatWithClaude;